import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models (pw2203 銷貨出庫單)
// ============================================================

export interface F2131 {
  f2131_01: string;         // 出庫單號 (FK)
  f2131_02: number;         // 項次
  f2131_03?: string;        // 備用欄位
  f2131_04?: string | null; // 明細日期
  f2131_07?: string;        // 庫號
  f2131_11: string;         // 產品代號
  f2131_11a?: string;       // 產品名稱 (自動帶入)
  f2131_12?: string;        // 單位 (自動帶入)
  f2131_13: number;         // 數量
  f2131_14: number;         // 單價
  f2131_15: number;         // 金額 (=ROUND(qty×price, 2))
  f2131_16?: number;        // 贈量
  f2131_17?: number;        // 折扣率
  f2131_18?: string;        // 明細摘要
  f2131_19?: number;        // 折扣後金額
  f2131_21?: string;        // 訂單編號
  f2131_22?: number;        // 訂單序號
  f2131_90?: number;
  f2131_91?: string;
  f2131_92?: string | null;
  f2131_93?: string;
}

export interface F2130M {
  f2130_01: string;         // 銷貨出庫單號 (PK)
  f2130_05?: string;        // 客戶代號
  f2130_07?: string;        // 庫號
  f2130_11: string | null;  // 出庫日期
  f2130_12?: string;        // 銷售人員代號
  f2130_13?: string;        // 公司/客戶代號
  f2130_14?: string;        // 發票號碼
  f2130_15?: string;        // 單據說明
  f2130_16?: number;        // 明細總項數
  f2130_17?: number;        // 明細金額小計
  f2130_18: number;         // 稅別 (1=含稅5%, 2=免稅)
  f2130_19?: number;        // 稅額
  f2130_20?: number;        // 含稅總金額
  f2130_21?: number;        // 已收總金額
  f2130_23?: number;        // 交通費
  f2130_24?: number;        // 其他費用
  f2130_25?: number;        // 運費
  f2130_26?: number;        // 折扣率
  f2130_28?: number;        // 未稅總金額
  f2130_29?: string;        // 公司名稱 (自動帶入)
  f2130_30?: string;        // 備註
  f2130_31?: string;        // 跳號別 (空白/M/P)
  f2130_33?: string;        // 建立人員 ID
  f2130_34?: string | null; // 核准日期
  f2130_80?: string;        // 狀態碼 (N=正常, P=核准)
  f2130_81?: string;        // 核准人員 ID
  f2130_82?: string | null; // 核准時間
  f2130_90?: number;        // Version
  f2130_91?: string;
  f2130_92?: string | null;
  f2130_93?: string;
  details?: F2131[];
}

export interface F2131Input {
  f2131_02?: number;
  f2131_11: string;
  f2131_11a?: string;
  f2131_12?: string;
  f2131_13: number;
  f2131_14: number;
  f2131_15?: number;
  f2131_16?: number;
  f2131_18?: string;
  f2131_21?: string;
  f2131_22?: number;
}

export interface CreatePW2203Request {
  master: Partial<F2130M>;
  details: F2131Input[];
}

export interface UpdatePW2203Request {
  master: Partial<F2130M>;
  details: F2131Input[];
}

export interface ListPW2203Response {
  data: F2130M[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

const BASE = '/api/pw2203';

export const pw2203Api = {
  async list(page = 1, size = 100): Promise<ListPW2203Response> {
    const res = await apiClient.get(BASE, { params: { page, size } });
    return res.data;
  },

  async search(kw: string, page = 1, size = 100): Promise<ListPW2203Response> {
    const res = await apiClient.get(`${BASE}/search`, { params: { kw, page, size } });
    return res.data;
  },

  async getByID(id: string): Promise<F2130M> {
    const res = await apiClient.get(`${BASE}/${encodeURIComponent(id)}`);
    return res.data;
  },

  async create(data: CreatePW2203Request): Promise<F2130M> {
    const res = await apiClient.post(BASE, data);
    return res.data;
  },

  async update(id: string, data: UpdatePW2203Request): Promise<F2130M> {
    const res = await apiClient.put(`${BASE}/${encodeURIComponent(id)}`, data);
    return res.data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`${BASE}/${encodeURIComponent(id)}`);
  },
};

export default pw2203Api;
